// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\np[data-v-6862d346] {\n  font-weight: 500;\n  font-size: var(--6862d346-size);\n  line-height: 150%;\n  color: var(--color-subTitle);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
